import React, { useMemo, useState } from 'react';
import { Autocomplete, TextField, Box, Checkbox, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CustomListbox from '../../../components/CustomListbox';

const formatLabel = (value) => value.replace(/([a-z])([A-Z])/g, '$1.$2').toLowerCase();

const EventSelect = ({ events = [], selected = [], onChange }) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  return (
    <Box>
      <Autocomplete
        multiple
        fullWidth
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={events}
        value={selected}
        inputValue={inputValue}
        onInputChange={(event, value, reason) => {
          if (reason === 'input') {
            setInputValue(value);
          }
        }}
        disableCloseOnSelect
        disableClearable
        ListboxComponent={CustomListbox}
        ListboxProps={{
          events,
          onSelectAll: () => onChange(events),
          onClearAll: () => onChange([]),
          sx: {
            backgroundColor: '#1e1e1e',
            paddingTop: 0,
            maxHeight: 256,
            overflowY: 'auto',
            '& .MuiAutocomplete-option': {
              color: '#fff',
              padding: '10px 14px',
              '&[aria-selected="true"]': {
                backgroundColor: '#1e1e1e !important',
              },
              '&:hover': {
                backgroundColor: '#4f46e5 !important',
              },
              '&[aria-selected="true"]:hover': {
                backgroundColor: '#4f46e5 !important',
              },
            },
          },
        }}
        getOptionLabel={(option) => formatLabel(option)}
        isOptionEqualToValue={(option, value) => option === value}
        onChange={(_, newValue) => {
          onChange(newValue);
        }}
        renderTags={(value) => {
          if (!value.length || open) return null;
          return <span style={{ marginLeft: 8, color: '#d1d5db' }}>{value.length} Event(s) selected</span>;
        }}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              checked={selected}
              icon={<span style={{ width: 16, height: 16 }} />}
              checkedIcon={<CheckIcon sx={{ color: '#fff', fontSize: 18 }} />}
              sx={{
                padding: 0,
                marginRight: 1.5,
                marginTop: '3px',
                color: '#fff',
              }}
            />
            <Box>
              <Typography fontSize={14} fontWeight={600} color="#fff">
                {formatLabel(option)}
              </Typography>
            </Box>
          </li>
        )}
        PaperProps={{
          sx: {
            backgroundColor: '#1e1e1e',
            borderRadius: 2,
            marginTop: 0.5,
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={selected.length === 0 || open ? 'Select Events' : ''}
            InputProps={{
              ...params.InputProps,
              sx: {
                paddingLeft: '8px',
                color: '#d1d5db',
                '& input::placeholder': {
                  color: '#9ca3af',
                  opacity: 1,
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default EventSelect;
